/** Short debounce to batch concurrent request failures into one verify. */
export const VERIFY_DEBOUNCE_MS = 1_000;

/** Minimum time to keep the manual refresh "checking" UI visible. */
export const MANUAL_REFRESH_MIN_MS = 1_000;

/** Base interval for Fibonacci backoff between repeated connectivity verifications. */
export const VERIFY_BACKOFF_BASE_MS = 60_000;

/** Upper bound for verify backoff (1 hour). */
export const MAX_VERIFY_BACKOFF_MS = 60 * 60 * 1000;

export function fibonacciMultiplier(step: number): number {
    if (step <= 0) {
        return 1;
    }

    let previous = 1;
    let current = 1;

    for (let index = 1; index < step; index++) {
        const next = previous + current;
        previous = current;
        current = next;
    }

    return current;
}

export function getVerifyBackoffMs(step: number): number {
    if (step <= 0) {
        return VERIFY_DEBOUNCE_MS;
    }

    return Math.min(VERIFY_BACKOFF_BASE_MS * fibonacciMultiplier(step), MAX_VERIFY_BACKOFF_MS);
}

export function nextVerifyBackoffStep(currentStep: number, remoteChecksOk: boolean): number {
    if (remoteChecksOk) {
        return 0;
    }

    return currentStep + 1;
}
